
import COVERAPP from '@/utils/COVERAPP';
import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'
import Xiaofeng from '../components/Xiaofeng.vue';

const posterText = '由封面AIGC内容创作平台生成';
@Options({
  data() {
    return {
      poster: '',
      text: '',
    }
  },
  components: {
    Xiaofeng,
  },
  computed: {
    ...mapState(['userInfo', 'shareData', 'activityData'])
  },
  mounted () {
    this.$common.pageLoaded()
    this.$common.track('load', '进入导航页')
    const shareData = JSON.parse(JSON.stringify(this.shareData))
    this.$common.onshare(shareData)
  },
  methods: {
    handlePoster() {
      this.$common.track('click', '点击抽取盲盒')
      this.poster = `https://yunyingcdn.thecover.cn/2024sclh/poster/${ Math.floor(Math.random() * 28) }.jpg`;
      this.showText();
    },
    showText() {
      let index = 0;
      const tint = setInterval(() => {
        this.text = posterText.slice(0, index);
        index++;
        if (index > posterText.length) {
          clearInterval(tint);
        }
      }, 100);
    },
    handleShare() {
      const poster = this.poster;
      const _this = this;
      console.log(poster);
      // 函数：从URL加载并转换图片为Base64
      function convertImageUrlToBase64(url, callback) {
        // 创建一个新的Image对象
        const img = new Image();
        
        // 设置跨域属性（如果需要的话）
        img.crossOrigin = 'anonymous';

        // 图片加载完成后的回调函数
        img.onload = function() {
          // 创建一个canvas元素
          const canvas = document.createElement('canvas');
          
          // 设置canvas尺寸与图片相同
          canvas.width = img.width;
          canvas.height = img.height;

          // 获取canvas的2D渲染上下文
          const ctx: any = canvas.getContext('2d');

          // 将图片绘制到canvas上
          ctx.drawImage(img, 0, 0);

          // 将canvas内容转为Base64编码，这里以PNG格式为例，也可以设置为'image/jpeg'等其他格式
          const base64String = canvas.toDataURL('image/png');

          // 调用回调函数传递Base64数据
          callback(base64String);
        };

        // 图片加载错误处理
        img.onerror = function(err) {
          console.error('Failed to load image:', err);
          callback(null, err);
        };

        // 开始加载图片
        img.src = url;
      }

      // 使用示例：
      convertImageUrlToBase64(poster, function(base64String, error) {
        if (error) {
          console.error('Error converting image:', error);
        } else {
          console.log('share');
          const homeShareData = JSON.parse(JSON.stringify(_this.shareData))
          console.log(homeShareData);
          COVERAPP.Method.shareImage({
            ...homeShareData,
            image: base64String.split(';base64,')[1],
            callback() {
              _this.$common.track('share', '分享海报图')
            },
          });
        }
      });
    },
  },
})
export default class Home extends Vue {}
